import { Typography, Grid2 as Grid } from '@mui/material';

const SecondFooter = () => {
  return (
    <Grid className="second-footer" container>
      <Grid size={12} align="center">
        <Typography color="textSecondary">
          Copyright @{new Date().getFullYear()} oneService •  Since 2017
        </Typography>
      </Grid>
    </Grid>
  )
}

export default SecondFooter;
